/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SourcingSearchFilterOnLocation
 */
export interface SourcingSearchFilterOnLocation {
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterOnLocation
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterOnLocation
     */
    longitude: number;
    /**
     * 
     * @type {number}
     * @memberof SourcingSearchFilterOnLocation
     */
    distanceRadiusInKilometers?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterOnLocation
     */
    shouldMatchAlternativeLocations?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterOnLocation
     */
    shouldMatchRemoteOnlyFreelancers?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SourcingSearchFilterOnLocation
     */
    shouldMatchWillingToTravelFreelancers?: boolean;
}

/**
 * Check if a given object implements the SourcingSearchFilterOnLocation interface.
 */
export function instanceOfSourcingSearchFilterOnLocation(value: object): value is SourcingSearchFilterOnLocation {
    if (!('latitude' in value) || value['latitude'] === undefined) return false;
    if (!('longitude' in value) || value['longitude'] === undefined) return false;
    return true;
}

export function SourcingSearchFilterOnLocationFromJSON(json: any): SourcingSearchFilterOnLocation {
    return SourcingSearchFilterOnLocationFromJSONTyped(json, false);
}

export function SourcingSearchFilterOnLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): SourcingSearchFilterOnLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'distanceRadiusInKilometers': json['distanceRadiusInKilometers'] == null ? undefined : json['distanceRadiusInKilometers'],
        'shouldMatchAlternativeLocations': json['shouldMatchAlternativeLocations'] == null ? undefined : json['shouldMatchAlternativeLocations'],
        'shouldMatchRemoteOnlyFreelancers': json['shouldMatchRemoteOnlyFreelancers'] == null ? undefined : json['shouldMatchRemoteOnlyFreelancers'],
        'shouldMatchWillingToTravelFreelancers': json['shouldMatchWillingToTravelFreelancers'] == null ? undefined : json['shouldMatchWillingToTravelFreelancers'],
    };
}

export function SourcingSearchFilterOnLocationToJSON(value?: SourcingSearchFilterOnLocation | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'distanceRadiusInKilometers': value['distanceRadiusInKilometers'],
        'shouldMatchAlternativeLocations': value['shouldMatchAlternativeLocations'],
        'shouldMatchRemoteOnlyFreelancers': value['shouldMatchRemoteOnlyFreelancers'],
        'shouldMatchWillingToTravelFreelancers': value['shouldMatchWillingToTravelFreelancers'],
    };
}

